module.exports = __webpack_public_path__ + "img/banner.f43f1c70.png";